import { Subject } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { RolService } from '../admin/services/rol.service';
import { TranslocoService } from '@ngneat/transloco';
import { takeUntil } from 'rxjs/operators';
import { UserService } from '../../@core/services/userService/user.service';
import { NotificacoesService } from '../admin/services/notificacoes.service';
import { Notificacoes } from '../admin/models/notificacoes';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { NotificacaoChangeService } from '../admin/services/notificacao-change.service';

@Component({
  selector: 'ngx-notificacoes',
  templateUrl: './notificacoes.component.html',
  styleUrls: ['./notificacoes.component.scss']
})
export class NotificacoesComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  notificacoes: any;
  objNotificacoes: Notificacoes[] = [];
  objNotificacoesList: Notificacoes[] = [];
  showEmptyMessage: boolean = false;
  loading: boolean = true;
  mostrarLidas: boolean = false;

  constructor(
    private dialogService: NbDialogService,
    private rolService: RolService,
    private i18nService2: TranslocoService,
    private userService: UserService,
    private notificacaoService: NotificacoesService,
    private router: Router,
    private notificacaoChangeService: NotificacaoChangeService,
    i18nService: TranslocoService) {
    i18nService.selectTranslation('notificacoes')
      .pipe(takeUntil(this.destroy$))
      .subscribe(i18n => {
        
        this.notificacoes = i18n;
      });
  }

  ngOnInit(): void {
    this.notificacaoService.getByUserId(this.userService.userId).subscribe(
      data => {
        this.loading = false;     
        data.forEach(n => {
          n.dataCriacaoFormat = moment(n.dataCriacao.toString().split("T")[0], "YYYY-MM-DD").format("DD/MM/YYYY").toString();
          this.objNotificacoes.push(n);
        })
        this.objNotificacoesList = this.objNotificacoes;

        if (this.objNotificacoes.length === 0)
          this.showEmptyMessage = true;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleClickNotificacao(notificacao: Notificacoes) {
    if (notificacao.dataLeitura === null) {
      this.notificacaoService.postMarcarComoLida(notificacao.id, this.userService.userId).subscribe(
        res => {
          this.notificacaoService.getNotificacoesNaoLidasByUser(this.userService.userId).subscribe(data => {
            this.notificacaoChangeService.attNotificacaoCountEvent.emit(data.length);
          })
        }
      );   
    }
      
    this.objNotificacoes.forEach(n => {
      if (n.id === notificacao.id && n.dataLeitura === null)
        n.dataLeitura = new Date();
    })
  }

  handleLink(notificacao: Notificacoes) {
    this.router.navigate(['/pages'+notificacao.url])
  }

  handleMarcarLidas() {
    this.notificacaoService.postMarcarTodasComoLidas(this.userService.userId).subscribe(
      res => {
        this.notificacaoService.getNotificacoesNaoLidasByUser(this.userService.userId).subscribe(data => {
          this.notificacaoChangeService.attNotificacaoCountEvent.emit(data.length);
        })
      }
    );
    this.objNotificacoes.forEach(n => {
        n.dataLeitura = new Date();
    })
  }

  handleMostrarNaoLidas() {
    if (!this.mostrarLidas) {
      this.objNotificacoes = [];
      this.objNotificacoesList.forEach(obj => {
        if (obj.dataLeitura === null)
          this.objNotificacoes.push(obj);
      })
    } else {
      this.objNotificacoes = this.objNotificacoesList;
    }
  }
}
